export default "__VITE_ASSET__CMaDixJQ__"